// components/steps/StepDiet.jsx
import React, { useState, useEffect } from 'react';

const dietOptions = [
  'Vegetarian',
  'Vegan',
  'Halal',
  'Kosher',
  'Gluten-free',
  'No preference'
];

const StepDiet = ({ data, updateData, skip, goBack }) => {
  // Use array for selections
  const [selected, setSelected] = useState(data.diet || []);

  // Sync when navigating back
  useEffect(() => {
    setSelected(data.diet || []);
  }, [data.diet]);

  const toggle = (opt) => {
    setSelected(prev =>
      prev.includes(opt)
        ? prev.filter(i => i !== opt)
        : [...prev, opt]
    );
  };

  const isNextDisabled = selected.length === 0;

  const handleNext = () => {
    if (!isNextDisabled) {
      updateData('diet', selected);
    }
  };

  return (
    <div className="bg-white/60 backdrop-blur p-6 rounded-xl shadow-lg max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-4 text-center">
        Do you have any dietary preferences?
      </h2>

      {/* Options Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
        {dietOptions.map(opt => (
          <button
            key={opt}
            onClick={() => toggle(opt)}
            className={`px-4 py-2 rounded-lg border text-sm transition-colors whitespace-nowrap
              ${selected.includes(opt)
                ? 'bg-blue-500 text-white border-transparent'
                : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'}`}
          >
            {opt}
          </button>
        ))}
      </div>

      {/* Navigation */}
      <div className="flex justify-between items-center">
        {goBack ? (
          <button
            onClick={goBack}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Back
          </button>
        ) : <div />}

        <div className="flex items-center gap-2">
          <button
            onClick={handleNext}
            disabled={isNextDisabled}
            className={`px-6 py-2 rounded-lg transition 
              ${isNextDisabled
                ? 'bg-blue-300 text-white cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'}`}
          >
            Next
          </button>
          <button
            onClick={skip}
            className="px-6 py-2 bg-transparent border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepDiet;
